module.exports = __webpack_public_path__ + "img/architecture-style-icon_4.54d05a4e.png";